import moment from "moment";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { Box, Grid, makeStyles, Typography } from "@material-ui/core";

import { COLORS } from "../../../../../theme/colors";
import { ShaDowBox } from "../../../../../components/boxes";
import { NoDataCard } from "../../../../../components/parts";
import { currencyFormatter, formatDatetime, getData } from "../../../../../services";

const useStyles = makeStyles((theme) => ({
  box: {
    minHeight: 213,
    padding: theme.spacing(2.25),
    backgroundColor: COLORS.darks[0][6],
    marginTop: theme.spacing(1.5),
  },
  grid: {
    marginBottom: 5,
  },
}));

const getRentalResults = (data, user, currencySymbol) => {
  return [
    {
      name: "Name of tenant:",
      value: data.tenant_name,
    },
    {
      name: "Leasing dates:",
      value: data.leasing_start ? (
        <>
          {formatDatetime(data.leasing_start, "MMM D, YYYY")}
          {data.leasing_end ? (
            <Typography
              component="span"
              style={{
                color: moment(data.leasing_end) < moment().add(60, "days") && COLORS.red,
              }}
            >
              <Typography component="span" style={{ color: COLORS.darks[0][100] }}>
                {" "}
                -{" "}
              </Typography>
              {formatDatetime(data.leasing_end, "MMM D, YYYY")}
            </Typography>
          ) : null}
        </>
      ) : null,
    },
    {
      name: "Leasing term:",
      value: data.leasing_term_days ? `${data.leasing_term_days} days` : null,
    },
    {
      name: "Leasing price:",
      value: `${currencyFormatter(data.leasing_price, currencySymbol)}/${user.unit_system}`,
    },
    {
      name: "Number of renewals:",
      value: data.number_renewals,
    },
    {
      name: "Number of tenants:",
      value: data.number_tenants,
    },
  ];
};

const getEconomicResults = (data, user, currencySymbol) => {
  return [
    {
      name: "Vacant since:",
      value: formatDatetime(data.vacant_since, "MMM D, YYYY"),
    },
    {
      name: "Target date to new tenancy (est.)",
      value: formatDatetime(data.target_date_new_tenancy, "MMM D, YYYY"),
    },
    {
      name: "Target leasing price (optional)",
      value: `${currencyFormatter(data.target_leasing_price, currencySymbol)}/${user.unit_system}`,
    },
  ];
};

export const TenancyDataDetail = ({ unit }) => {
  const classes = useStyles();
  const { user } = useSelector((state) => state.auth);
  const currencySymbol = user.currency.symbol;
  const title = "Tenancy Data";
  const [results, setResults] = useState([]);

  useEffect(() => {
    getData(
      `/praas/v2/buildings/${unit.building.id}/properties/units/${unit.id}/tenancy-data/`,
      (data) => {
        const getResults = unit.tenancy_status === "RENTED" ? getRentalResults : getEconomicResults;
        setResults(getResults(data, user, currencySymbol));
      }
    );

    return () => setResults();
  }, []);

  if (!results.length) return <NoDataCard title={title} />;

  return (
    <ShaDowBox fullHeight>
      <Box style={{ padding: 24 }}>
        <Typography variant="h4">{title}</Typography>
        <Box className={classes.box}>
          {results.map((result, i) => (
            <Grid key={i} container justifyContent="space-between" className={classes.grid}>
              <Grid item>
                <Typography>{result.name}</Typography>
              </Grid>
              <Grid item>
                <Typography>{result.value}</Typography>
              </Grid>
            </Grid>
          ))}
        </Box>
      </Box>
    </ShaDowBox>
  );
};
